import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustommatdateService } from '../services/custommatdate.service';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DatePipe, KeyValue } from '@angular/common';
import { debounceTime, filter, startWith, Subject } from 'rxjs';
import { FormDTO, Prefrence, ReferralAddress, ReferralMember, ReferralResponse, verifyMemberRequest, verifyMemberResponse } from '../model/interfaces';
import { accountCheckFields, addFamilyMemberFields, defaultFormDtoObj, defaultMailAddressObj, defaultMemberObj, defaultResAddressObj, defaultResponseDtoObj, defaultValidateMemberObj, employerPolicyCheckFields, familyMemberCheckFields, policyHolderCheckFields } from '../model/default-data';
import { FormControl, FormGroup, NgForm, NgModel } from '@angular/forms';
import { DataService } from '../services/data.service';
import { LoggerService } from '../services/logger.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AddressService } from 'src/app/shared/address.service';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { ValidationService } from '../services/validation.service';
import * as moment from 'moment';
import { AlertComponent } from '../dialog/alert.component';
import { CaptchaService } from 'src/app/shared/captcha.service';
import { config } from 'src/app/shared/config';
const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'MMDDYYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'MM/DD/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-flform',
  templateUrl: './flform.component.html',
  styleUrls: ['./flform.component.css'],
  providers: [
      { provide: DateAdapter, useClass: CustommatdateService },
      { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
      { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
      {
        provide: STEPPER_GLOBAL_OPTIONS,
        useValue: { displayDefaultIndicatorType: false },
      },
    ],
})
export class FlformComponent implements OnInit , OnChanges {
  public datePipe: DatePipe;
  captchaText: string = '';
  timerReset: number = 0;
  apiError: HttpErrorResponse | undefined;
  private _success = new Subject<string>();
  private _warning = new Subject<string>();
  private _danger = new Subject<string>();
  addressSuggestions: any = {
    resAddress: [],
    mailAddress: [],
    referralPolicyAddress: [],
    referralEmployerAddress: []
  }

  disableSearch=false;
  isRoutingNumberValid:boolean = true;
  accountType: string |undefined;
  isValidFormSubmitted: boolean = false;
  model2: string | undefined;
  staticAlertClosed = false;
  ssnValidationError: string = '';
  signFirstName: string = '';
  signLastName: string = '';
  signApplicant: string = '';
  sendInformationCheck: boolean = false;
  signElectronicSignatureChecked: boolean = false;
  emailTxtRequired: boolean = false;
  homeLess: string = '';
  isSameMailingAddress: string = '';
  isHealthInsurance: string = '';
  isMemberMedicaid: string = '';
  existingMember: string | null = null;
  existingOtherMember: string | null = null;
  existingMemberVerified: boolean = false;
  updateReason: string = '';
  sourceCdRequired: boolean = false;
  memberGenderRequired: boolean = false;
  premiumAmountRequired: boolean = false;
  employerPremiumAmountRequired: boolean = false;
  frequencyRequired: boolean = false;
  planTierRequired: boolean = false;
  isFamilyRequired: boolean = false;
  signCheckRequired: boolean = false;
  signElectronicRequired: boolean = false;
  signApplicantRequired: boolean = false;
  signfirstNmRequired: boolean = false;
  signLastNameRequired: boolean = false;
  captchaRequired: boolean = false;
  editIndex?: number = undefined;
  otherFnRequired: boolean = false;
  otherLnRequired: boolean = false;
  otherSsnRequired: boolean = false;
  otherDobRequired: boolean = false;
  otherGnRequired: boolean = false;
  otherRsRequired: boolean = false;
  otherEnrolledRequired: boolean = false;
  othermaNumRequired: boolean = false;
  addClearFamilyFilled: boolean = false;
  pregnantMemberRequired: boolean = false;
  pregnantOtherRequired: boolean = false;
  additionalMembersReq: boolean = false;
  homelessCountyRequired: boolean = false;
  resAddress1Required: boolean = false;
  resParishRequired: boolean = false;
  resCityRequired: boolean = false;
  resStateRequired: boolean = false;
  resZipRequired: boolean = false;
  isSameRequired: boolean = false;
  mailAddress1Required: boolean = false;
  mailParishRequired: boolean = false;
  mailCityRequired: boolean = false;
  mailStateRequired: boolean = false;
  mailZipRequired: boolean = false;
  updateReasonRequired: boolean = false;
  refferalSourceRequired: boolean = false;
  firstNameRequired: boolean = false;
  lastNameRequired: boolean = false;
  ssnMemberRequired: boolean = false;
  memberDobRequired: boolean = false;
  memberMedicateRequired: boolean = false;
  homelessRequired: boolean = false;
  eplyrNmRequired: boolean = false;
  emplyrAddr1Required: boolean = false;
  emplyrAddr2Required: boolean = false;
  emplyrCityRequired: boolean = false;
  emplyrStateRequired: boolean = false;
  emplyrZipCodeRequired: boolean = false;
  emplyrPhoneRequired: boolean = false;
  emplyrFeinRequired: boolean = false;
  emplyrErollDateRequired: boolean = false;
  emplyrErollEndDateRequired: boolean = false;
  policyNmRequired: boolean = false;
  policyAddr1Required: boolean = false;
  policyAddr2Required: boolean = false;
  policyCityRequired: boolean = false;
  policyStateRequired: boolean = false;
  policyZipCodeRequired: boolean = false;
  policyPhoneRequired: boolean = false;
  policyPlanNmRequired: boolean = false;
  policyIdRequired: boolean = false;
  policyGroupNumRequired: boolean = false;
  policyStartRequired: boolean = false;
  directDepositRequired: boolean = false;
  directDepositCheck: boolean = false;

  addMember: boolean = false;

  showResAddress: boolean = false;
  showMailAddress: boolean = false;
  showEmployerAddress: boolean = false;
  showPolicyAddress: boolean = false;
  @ViewChild('routingNumber') routingNumberNgModel!: NgModel;
  successMessage: string = '';
  warningMessage: string = '';
  pregnantMember: string = '';
  pregnantOther: string = '';
  otherEnrolled: string = '';
  cobra: string = '';
  isFamilyMemberMedicate: string = '';
  captchaEntered: string = '';
  errorMessage: string = '';
  operationText = 'Submit';

  @Input() errorMessageIntialData: string = '';
  isSsnPresentDB: boolean = false;
  memberVOdobDt!: Date;
  employerErollStartDate!: Date | null;
  employerErollEndDate!: Date | null;
  policyVOpolicyStartDate!: Date;
  cobraStartDate!: Date;
  cobraEndDate!: Date;
  otherdobDate!: Date | null;

  depositBankName: string = '';
  depositBankNmRequired: boolean = false;
  depositRoutingNum: string = '';
  routingNumRequired: boolean = false;
  depositAccountNum: string = '';
  accountNumRequired: boolean = false;
  accountTypeRequired: boolean = false;
  memberVOmaNumRequired: boolean = false;

  addFamilyMemberButton: boolean = false;
  stateRestrciton: boolean = false;
  requiredState: string = '';

  today: Date = today;
  plus1year: Date = new Date(year + 1, month, today.getDate());
  prev10year: Date = new Date(year - 10, month, today.getDate());
  next5year: Date = new Date(year + 5, month, today.getDate());
  prev100year: Date = new Date(year - 100, month, today.getDate());

  otherfirstNm: string = '';
  otherlastNm: string = '';
  othermiNm?: string = '';
  otherssnNum: string = '';
  othermaNum?: string = '';
  othergencdRf?: string = '';
  otherrshcdRf?: string = '';
  otherSpecialCond?: string = '';
  parish: string = '';
  homelessCounty: string = '';
  alreadySubmitted: boolean = false;
  memberObj1: ReferralMember = defaultMemberObj;
  resAddress: ReferralAddress = defaultResAddressObj;
  mailAddress: ReferralAddress = defaultMailAddressObj;
  submittedResponse: ReferralResponse = defaultResponseDtoObj;
  formFl: FormDTO = defaultFormDtoObj;
  verifyMember: verifyMemberRequest = defaultValidateMemberObj;
  additionalMaxReached: boolean = false;
  memberPierId: string | null = null;
  otherMemberPierId: string | null = null;
  existingInvalidMemberName: string = '';



  resAddressFormControl = new FormGroup({
    addressTypeCd: new FormControl('R'),
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl(''),
  });

  mailAddressFormControl = new FormGroup({
    addressTypeCd: new FormControl('M'),
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl(''),
  });


  referralPolicyAddressFormControl = new FormGroup({
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl('')
  });


  referralEmployerAddressFormControl = new FormGroup({
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl('')
  });


  @Input() preference: Prefrence | null = null;
  @Input() email: string | undefined = '';
  @Input() tollfreeNo: string | undefined | null = '';
  @Input() faxNo: string | undefined | null = '';
  @Input() mailingAddress: string = '';
  @Input() dropingAddress: string = '';
  @Input() emailTo: string = '';
  @Input() mailingOffice: string = '';
  @Input() mailingAddressLine: string = '';
  @Input() mailingCityStateZip: string = '';

  @ViewChild('customerForm')
  customerForm: NgForm = {} as NgForm;

  @ViewChild('captcha')
  captcha: NgModel = {} as NgModel;

  @ViewChild('MemberSsn')
  MemberSsn: NgModel = {} as NgModel;

  @ViewChild('otherSsn')
  otherSsn: NgModel = {} as NgModel;

  @ViewChild('otherDob')
  otherDob: NgModel = {} as NgModel;

  @ViewChild('residentialAddress') inputField!: ElementRef<HTMLInputElement>;
  // @ViewChild('mailingAddress') mailingAddress!: ElementRef<HTMLInputElement>;
 @ViewChild('emplyrAddress') emplyrAddress!: ElementRef<HTMLInputElement>;
 @ViewChild('policyAddress') policyAddress!: ElementRef<HTMLInputElement>;
 previousValRes: any;
 previousValMail: any;
 previousValRefEmp: any;
 previousValRefPol: any;

 ngAfterViewInit() {
   // Disable browser autocomplete for the input field
   if(this.inputField){
     this.inputField.nativeElement.setAttribute('autocomplete', 'new-password');
     // Optional: Programmatically focus on the input field
     this.inputField.nativeElement.focus();
   }
 }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.errorMessageIntialData != '') {
      this.errorMessage = this.getMessageServerDown();
      setTimeout(() => {
        this.changeResetMessage();
        this.errorMessage = '';
      }, 10000);
    }
  }

  ngOnInit(): void {
    this.captchaText = this.captchaService.generateCaptcha();
    this._success.subscribe((message) => (this.successMessage = message));
    this._success.pipe(debounceTime(5000)).subscribe(() => {
      this.successMessage = '';
      //window.location.reload();
    });
    this._danger.subscribe((message) => (this.errorMessage = message));
    this._danger.pipe(debounceTime(8000)).subscribe(() => {
      this.errorMessage = '';
      //window.location.reload();
    });
    this._warning.subscribe((message) => (this.warningMessage = message));
    this._warning.pipe(debounceTime(2000)).subscribe(() => {
      this.warningMessage = '';
      if (!(window as any).__KARMA_TEST_MODE__) {
        window.location.reload();
      }
    });

    let resAddressLine1 = this.resAddressFormControl.controls.address1Txt;
    this.resAddressFormControl.controls.address1Txt.valueChanges.pipe(
      startWith(''),
      filter(() => !this.disableSearch),
      debounceTime(1000),
    ).subscribe(val => {
      if(this.disableSearch || !val) return;
      if(val?.length<6){
        this.previousValRes="";
      }
      if (this.previousValRes?.trim() == resAddressLine1?.value?.trim()) return;
      if(this.resAddressFormControl.controls.zipCd.value) return;
      if(
        this.resAddressFormControl.controls.address1Txt.value =='PO BOX') {
       this.addressSuggestions.resAddress = [];
       return
     }
     if(val?.length>5){
      this.setPreviousVal(val, 'resAddress');
      this.fetchAddressList(this.resAddressFormControl, this.resAddressFormControl.controls.address1Txt,'FL', true, 'resAddress')
     }
  })

  let mailAddressLine1 = this.mailAddressFormControl.controls.address1Txt;
    this.mailAddressFormControl.controls.address1Txt.valueChanges.pipe(
      startWith(''),
      filter(() => !this.disableSearch),
      debounceTime(1000),
    ).subscribe(val => {
      if(this.disableSearch || !val) return;
      if(val?.length<6){
        this.previousValMail="";
      }
      if (this.previousValMail?.trim() == mailAddressLine1?.value?.trim()) return;
      if(this.mailAddressFormControl.controls.zipCd.value) return;
      if(val?.length>5){
        this.setPreviousVal(val, 'mailAddress');
        this.fetchAddressList(this.mailAddressFormControl, this.mailAddressFormControl.controls.address1Txt, '', false, 'mailAddress')
      }
  })

  let refEmpAddressLine1 = this.referralEmployerAddressFormControl.controls.address1Txt;
  this.referralEmployerAddressFormControl.controls.address1Txt.valueChanges.pipe(
    startWith(''),
    filter(() => !this.disableSearch),
    debounceTime(1000),
  ).subscribe(val => {
    if(this.disableSearch || !val) return;
    if(val?.length<6){
      this.previousValRefEmp="";
    }
    if (this.previousValRefEmp?.trim() == refEmpAddressLine1?.value?.trim()) return;
    if(this.referralEmployerAddressFormControl.controls.zipCd.value) return;
    if(val?.length>5){
      this.setPreviousVal(val, 'referralEmployerAddress');
      this.fetchAddressList(this.referralEmployerAddressFormControl, this.referralEmployerAddressFormControl.controls.address1Txt, '', false, 'referralEmployerAddress')
    }
  })

  let refPolAddressLine1 = this.referralPolicyAddressFormControl.controls.address1Txt; 
  this.referralPolicyAddressFormControl.controls.address1Txt.valueChanges.pipe(
    startWith(''),
    filter(() => !this.disableSearch),
    debounceTime(1000),
  ).subscribe(val => {
    if(this.disableSearch || !val) return;
    if(val?.length<6){
      this.previousValRefPol="";
    }        
    if (this.previousValRefPol?.trim() == refPolAddressLine1?.value?.trim()) return;   
    if(this.referralPolicyAddressFormControl.controls.zipCd.value) return;
    if(val?.length>5){
      this.setPreviousVal(val, 'referralPolicyAddress');
      this.fetchAddressList(this.referralPolicyAddressFormControl, this.referralPolicyAddressFormControl.controls.address1Txt, '', false, 'referralPolicyAddress')
    }
  })
  }

  generateCaptcha(): void {
    this.captchaText = this.captchaService.generateCaptcha();
  }
  playCaptchaAudio(): void {
    this.captchaService.playCaptchaAudio();
  }

  fetchAddressList(formGroup: FormGroup, control: FormControl, requiredState: string, stateRestrciton: boolean, propName: string) {
    if(control.value.length > 5){
      const resAddress = formGroup.getRawValue();
      let address1Line = this.capitalize(control.value.toLowerCase());
      let existingAddress = this.addressSuggestions[propName].filter((item: any)  => 
        item.street_line?.includes(address1Line));
      if(this.addressSuggestions[propName].length >0 && existingAddress.length>0){
        this.addressSuggestions[propName] = existingAddress;
       
      }else{
        this.addressService.autocompleteAddress(resAddress, requiredState, stateRestrciton).then(
          (data:any)=> {
            if(propName=='resAddress'){
              const filteredResults = data.suggestions.filter((result: { street_line: string; }) =>!this.isPOBox(result?.street_line));
              this.addressSuggestions[propName] = filteredResults;
            } else {
              this.addressSuggestions[propName] = data.suggestions;
            }
            // this.initRequest[propName] = false;
            if(this.addressSuggestions[propName].length ==0) {
              if( resAddress.cityTxt=='' || resAddress.stateCd=='' ||resAddress.zipCd==''){
                control.setErrors({...(control.errors || {}),'invalid': true});
              }else{
                if(control.errors)
                    delete  control.errors['invalid'];
              }
            }
          }
        );
      }
      
    }else{
      this.addressSuggestions[propName] =[];
    }
    
  }
  capitalize(value: string): string {
    if (!value) return value;
    return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

   // Method to check if an address contains a PO Box
 isPOBox(address:string):boolean {
  const poBoxPatterns = [/P\.?O\.?\s?Box/i, /Post\s?Office\s?Box/i];
  // Add more patterns if needed
  return poBoxPatterns.some(pattern =>
  pattern.test(address));
}

  constructor(
    private dataService: DataService,
    private logger: LoggerService,
    private deviceDetectorService: DeviceDetectorService,
    private addressService: AddressService,
    private changeDetector: ChangeDetectorRef,
    private dialog: MatDialog,
    private captchaService: CaptchaService
  ) {
    this.datePipe = new DatePipe('en-US');
  }

  ngAfterContentChecked(): void {
    this.changeDetector?.detectChanges();
  }

  policyHolderCheck() {
    const resAddress = this.resAddressFormControl.value;
    const mailAddress = this.mailAddressFormControl.value;
    let requiredFields: boolean =
      this.existingMember != '' &&
      ((this.existingMember == 'No' &&
        this.formFl.referralCase.referralSource != '') ||
        (this.existingMember == 'Yes' && this.updateReason != '')) &&
      this.memberObj1.firstNm != '' &&
      this.memberObj1.lastNm != '' &&
      this.memberObj1.ssnNum != '' &&
      this.memberVOdobDt != null &&
      this.isMemberMedicaid != '' &&
      this.memberObj1.genderCd != '' &&
      (this.isMemberMedicaid == 'No' ||
        (this.isMemberMedicaid == 'Yes' && this.memberObj1.maNum != '')) &&
       resAddress.address1Txt != '' &&
       resAddress.stateCd != '' &&
       resAddress.zipCd != '' &&
       resAddress.cityTxt != '' &&
       (!this.formFl.referralCase.emailSignup || this.formFl.referralCase.emailSignup  && this.formFl.referralCase.emailTxt != '') &&
       this.isSameMailingAddress != '' &&
       ((this.isSameMailingAddress == 'No' &&
        mailAddress.address1Txt != '' &&
        mailAddress.stateCd != '' &&
        mailAddress.zipCd != '' &&
        mailAddress.cityTxt != '' ) ||
        this.isSameMailingAddress == 'Yes');

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = policyHolderCheckFields;
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
    }

    return requiredFields && valid;
  }

  onFocusInput() {
    //this.addressSuggestions = [];
  }

  validateAdress(address: ReferralAddress, formGroup: FormGroup) {
    let valid = true;
    let addressControl = formGroup.controls['address1Txt'];
    if(address.address1Txt =="" ){
      if(addressControl.errors && addressControl.hasError('invalid') ){
        if(addressControl.hasError('required')){
          addressControl.setErrors({
            required: true, invalid: false
          });
        }
       
      }else{
        addressControl.setErrors({
          required: true
        });
      }
      valid = false;
    }else if(address.cityTxt =="" || address.stateCd =="" || address.cityTxt =="" ){
      if(!(addressControl.errors && addressControl.hasError('po')) && !(addressControl.errors && addressControl.hasError('invalid'))){
        addressControl.setErrors({invalid: true});
      }     
      valid = false;
    }else{
      if(addressControl.errors && addressControl.hasError('invalid') ){
        if(!addressControl.hasError('po')){
          if(!addressControl.hasError('required'))
            addressControl.setErrors(null);
        }else{
          addressControl.setErrors({
            invalid: false, po: true
          });
        }
      }
        
    }    
    return valid;
  }

  farword() {
    if (this.existingMember != '') {
      if (this.existingMember == 'Yes' && this.updateReason == '') {
        this.updateReasonRequired = true;
      }
      if (this.existingMember == 'No') {
        this.refferalSourceRequired = true;
      }
      this.firstNameRequired = true;
      this.lastNameRequired = true;
      if (this.MemberSsn.value == '') {
        this.ssnMemberRequired = true;
      }
      this.validateAdress(<ReferralAddress>this.resAddressFormControl.getRawValue(), this.resAddressFormControl);
      if(this.isSameMailingAddress == 'No'){
        this.validateAdress(<ReferralAddress>this.mailAddressFormControl.getRawValue(), this.mailAddressFormControl);
      }
      this.memberDobRequired = true;
      this.memberMedicateRequired = true;
      this.memberGenderRequired = true;
      if(this.resAddressFormControl.controls.address1Txt.value ==""){
        this.resAddress1Required = true;
      }
      
      this.isSameRequired = true;
      if(this.isSameMailingAddress =='No' && this.mailAddressFormControl.controls.address1Txt.value ==""){
        this.mailAddress1Required = true;
      }
      if(this.formFl.referralCase.emailSignup){
        this.emailTxtRequired = true;
      }   
      this.memberVOmaNumRequired = true;
    } else {
      this.updateReasonRequired = false;
      this.refferalSourceRequired = false;
      this.firstNameRequired = false;
      this.emailTxtRequired = false;
      this.memberVOmaNumRequired = false;
      this.lastNameRequired = false;
      this.ssnMemberRequired = false;
      this.memberDobRequired = false;
      this.memberGenderRequired = false;
      this.memberMedicateRequired = false;
      this.resAddress1Required = false;
      this.resCityRequired = false;
      this.resStateRequired = false;
      this.resZipRequired = false;
      this.isSameRequired = false;
      this.mailAddress1Required = false;
      this.mailCityRequired = false;
      this.mailStateRequired = false;
      this.mailZipRequired = false;
    }
    this.timerReset =Math.random()* 100;
  }
  employerPolicyCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.formFl.referralPolicy.policySourceCd != '' &&
      ((this.existingMember == 'Yes' &&
        this.formFl.referralPolicy.employeePremium != '' &&
        this.formFl.referralPolicy.employerPremium != '' &&
        this.formFl.referralPolicy.planTier != '' &&
        this.formFl.referralPolicy.frequency != '') ||
        (this.existingMember == 'No' &&
          this.formFl.referralEmployer.emplyrNm != '' &&
          this.referralEmployerAddressFormControl.controls.address1Txt.value != '' &&
          this.referralEmployerAddressFormControl.controls.cityTxt.value != '' &&
          this.referralEmployerAddressFormControl.controls.stateCd.value != '' &&
          this.referralEmployerAddressFormControl.controls.zipCd.value != '' &&
          this.formFl.referralEmployer.phoneNum != '' &&
          this.formFl.referralEmployer.emplyrFein != '' &&
          this.employerErollStartDate != null &&
          this.employerErollEndDate != null));

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = employerPolicyCheckFields;
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
      if(this.referralEmployerAddressFormControl.controls.address1Txt.errors){
        valid = false;
      }
      if(this.referralPolicyAddressFormControl.controls.address1Txt.errors){
        valid = false;
      }
    }

    return requiredFields && valid;
  }
  goBack() {
    this.sourceCdRequired = false;
    this.premiumAmountRequired = false;
    this.employerPremiumAmountRequired = false;
    this.frequencyRequired = false;
    this.planTierRequired = false;
    this.eplyrNmRequired = false;
    this.emplyrAddr1Required = false;
    this.emplyrAddr2Required = false;
    this.emplyrCityRequired = false;
    this.emplyrStateRequired = false;
    this.emplyrZipCodeRequired = false;
    this.emplyrPhoneRequired = false;
    this.emplyrFeinRequired = false;
    this.emplyrErollDateRequired = false;
    this.emplyrErollEndDateRequired = false;
    this.policyNmRequired = false;
    this.policyAddr1Required = false;
    this.policyAddr2Required = false;
    this.policyCityRequired = false;
    this.policyStateRequired = false;
    this.policyZipCodeRequired = false;
    this.policyPhoneRequired = false;
    this.policyPlanNmRequired = false;
    this.policyIdRequired = false;
    this.policyGroupNumRequired = false;
    this.policyStartRequired = false;
  }
  goForward() {
    if (this.policyHolderCheck() && !this.employerPolicyCheck()) {
      if (this.existingMember == 'No') {
        this.eplyrNmRequired = true;
        if(this.referralEmployerAddressFormControl.controls.address1Txt.value ==""){
          this.emplyrAddr1Required = true;
        }   
        this.validateAdress(<ReferralAddress>this.referralEmployerAddressFormControl.getRawValue(), this.referralEmployerAddressFormControl);   
        this.emplyrPhoneRequired = true;
        this.emplyrFeinRequired = true;
        this.emplyrErollDateRequired = true;
        this.emplyrErollEndDateRequired = true;
      }
      this.sourceCdRequired = true;
      if (this.existingMember == 'Yes') {
        this.premiumAmountRequired = true;
        this.employerPremiumAmountRequired = true;
        this.frequencyRequired = true;
        this.planTierRequired = true;
      }
    }
    this.timerReset =Math.random()* 100;
  }

  familyMemberCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.isFamilyMemberMedicate != '' &&
      ((this.checkAdditionalMembers() && this.isFamilyMemberMedicate != '') ||
        this.isFamilyMemberMedicate == 'No');

    let valid = true;
    const form = this.customerForm?.form;

    if (requiredFields && form != null) {
      let page1 = familyMemberCheckFields;
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
    }
    let checkFmailyFilled: boolean = false;
    if (
      this.otherfirstNm != '' &&
      this.otherlastNm != '' &&
      (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') &&
      this.otherEnrolled != '' &&
      this.otherssnNum != '' &&
      this.othermaNum != '' &&
      this.othergencdRf != '' &&
      this.otherrshcdRf != ''
    ) {
      checkFmailyFilled = true;
    } else {
      checkFmailyFilled = false;
    }

    return (
      requiredFields &&
      valid &&
      !checkFmailyFilled &&
      !(this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No')
    );
  }
  goBack2() {
    this.isFamilyRequired = false;
    this.additionalMembersReq = false;
    this.additionalMaxReached = false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.otherGnRequired = false;
    this.otherEnrolledRequired = false;
    this.otherDobRequired = false;
    this.othermaNumRequired = false;
    this.otherSsnRequired = false;
    this.otherRsRequired = false;
    this.addClearFamilyFilled = false;
  }
  goForward2() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      !this.familyMemberCheck()
    ) {
      this.isFamilyRequired = true;
    }

    if (!this.checkAdditionalMembers()) {
      this.additionalMembersReq = true;
    } else {
      this.additionalMembersReq = false;
    }
    if (
      this.isFamilyMemberMedicate == 'Yes' &&
      this.formFl.referralMemberList.length > 50
    ) {
      this.additionalMaxReached = true;
    } else {
      this.additionalMaxReached = false;
    }

    if (
      this.otherfirstNm != '' ||
      this.otherlastNm != '' ||
      (this.otherdobDate != null && this.otherDob!=null &&  this.otherDob.control.value !='') ||
      this.otherEnrolled != '' ||
      this.otherssnNum != '' ||
      this.othermaNum != '' ||
      this.othergencdRf != '' ||
      this.otherrshcdRf != ''
    ) {
      this.addClearFamilyFilled = true;
    } else {
      this.addClearFamilyFilled = false;
    }
    this.timerReset =Math.random()* 100;
  }

  rightsResponsibilityCheck() {
    return (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      (!this.directDepositCheck ==true ||
        (this.directDepositCheck ==true && this.directDepositFn()))
    );
  }

  directDepositFn() {
    const routingCtrl = this.customerForm?.form.controls['deposit.routingNum'];

    if (this.routingNumberNgModel) {
    this.routingNumberValidator(
      { target: { value: this.depositRoutingNum } },
      this.routingNumberNgModel
    );
    }
    let requiredFields: boolean =
      this.familyMemberCheck() &&(!this.directDepositCheck ==true || (this.directDepositCheck ==true && this.depositAccountNum != '' &&
        this.accountType != undefined   &&
        this.depositBankName != '' &&
        this.depositRoutingNum != '' && routingCtrl.valid));


    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = accountCheckFields;
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
    }

    return requiredFields && valid;
  }

  clear(event: Event) {
    this.goBack3();
    this.addClearFamilyFilled = false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.otherEnrolledRequired = false;
    this.otherSsnRequired = false;
    this.othermaNumRequired = false;
    this.otherDobRequired = false;
    this.otherGnRequired = false;
    this.otherRsRequired = false;
    this.otherfirstNm = '';
    this.otherlastNm = '';
    this.othermiNm = '';
    this.otherssnNum = '';
    this.othermaNum = '';
    this.othergencdRf = '';
    this.otherrshcdRf = '';
    this.otherSpecialCond = '';
    this.otherdobDate = null;
    if(this.otherDob && this.otherDob.control){
      this.otherDob.control.setValue('');
      this.otherDob.control.setErrors(null);
    }
    this.otherEnrolled = '';
    this.addMember = true;
  }
  goBack3() {
    this.signCheckRequired = false;
    this.depositBankNmRequired = false;
    this.routingNumRequired = false;
    this.accountNumRequired = false;
    this.accountTypeRequired = false;
  }
  goForward3() {
    if (this.directDepositCheck == true) {
      this.depositBankNmRequired = true;
      this.routingNumRequired = true;
      this.accountNumRequired = true;
      this.accountTypeRequired = true;
    } else {
      this.depositBankNmRequired = false;
      this.routingNumRequired = false;
      this.accountNumRequired = false;
      this.accountTypeRequired = false;
    }
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() && !this.directDepositFn() && this.isRoutingNumberValid
    ) {
      if (this.directDepositCheck == true) {
        this.depositBankNmRequired = true;
        this.routingNumRequired = true;
        this.accountNumRequired = true;
        this.accountTypeRequired = true;
      } else {
        this.depositBankNmRequired = false;
        this.routingNumRequired = false;
        this.accountNumRequired = false;
        this.accountTypeRequired = false;
      }
    }
    this.signCheckRequired = true;
    this.timerReset =Math.random()* 100;
  }
  submitCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.directDepositFn() &&
      this.signElectronicSignatureChecked ==true &&
      this.signApplicant !='' &&
      this.formFl.referralCase.submitterFirstName != '' &&
      this.formFl.referralCase.submitterLastName != '' &&
      this.captchaEntered != '';

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = ['signfirstNm', 'signLastName', 'captcha'];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
    }

    return requiredFields && valid;
  }
  goBack5() {
    this.signfirstNmRequired = false;
    this.signLastNameRequired = false;
    this.captchaRequired = false;
  }
  goForward5() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.directDepositFn()
    ) {
      this.signElectronicRequired =true;
      this.signApplicantRequired = true;
      this.signfirstNmRequired = true;
      this.signLastNameRequired = true;
      this.captchaRequired = true;
    }
    if (this.submitCheck()) {
      this.submit();
    }
    this.timerReset =Math.random()* 100;
  }
  submit() {
    if (this.captchaEntered == '') {
      return;
    } else if (this.captchaEntered != this.captchaText) {
      return;
    }
    this.existingOtherMember = 'No';
    this.otherMemberPierId = null;
    if(this.memberPierId == null && this.formFl.referralMemberList.length > 0){

      this.formFl.referralMemberList.forEach(mem => {
        if (mem.memberPierId != null){
          this.otherMemberPierId=  mem.memberPierId;
          this.existingOtherMember = 'Yes';
          mem.memberPierId = null;
        }

      });
    }else if(this.memberPierId == null && this.formFl.referralMemberList.length == 0 ){
      this.otherMemberPierId=  null;
    }
    if (this.existingMember == 'Yes' || (this.formFl.referralMemberList.length > 0 && this.existingOtherMember == 'Yes')) {
      this.formFl.referralCase.existingCase = true;
      this.formFl.referralCase.pierId = this.memberPierId!=null? this.memberPierId: this.otherMemberPierId;
    }
    if (this.directDepositCheck == true && this.formFl.referralAccount != null) {
      this.formFl.referralAccount.accountNumber = this.depositAccountNum;
      this.formFl.referralAccount.accountType = this.accountType;
      this.formFl.referralAccount.bankName = this.depositBankName;
      this.formFl.referralAccount.routingNumber = this.depositRoutingNum;
    } else {
      this.formFl.referralAccount = null;
    }

    if (this.existingMember == 'Yes') {
      this.formFl.referralCase.updateReason = this.updateReason;
    }
    this.formFl.referralEmployer.openEnrollmentStartDate = this.getServerDate(
      this.employerErollStartDate
    );
    this.formFl.referralEmployer.openEnrollmentEndDate = this.getServerDate(
      this.employerErollEndDate
    );

    // this.formFl.referralAddressList.push(<ReferralAddress>this.resAddressFormControl.getRawValue());
    // if(this.isSameMailingAddress=='No'){
    //   this.formFl.referralAddressList.push(<ReferralAddress>this.mailAddressFormControl.getRawValue());
    // }

    if(this.isSameMailingAddress =='Yes'){
      this.mailAddressFormControl.patchValue(this.resAddressFormControl.getRawValue())
    }
    this.formFl.referralAddressList.push(<ReferralAddress>this.resAddressFormControl.getRawValue());
    if(this.isSameMailingAddress=='No'){
      this.formFl.referralAddressList.push(<ReferralAddress>this.mailAddressFormControl.getRawValue());
    }
    this.memberObj1.recipientPerson = this.isMemberMedicaid == 'Yes';
    this.memberObj1.enrolledInPolicy = true;
    this.memberObj1.dobDt = this.getServerDate(this.memberVOdobDt);
    this.formFl.referralPolicy.policyStartDate = this.getServerDate(
      this.policyVOpolicyStartDate
    );
    this.formFl.referralCase.submittedByPh = this.signApplicant == 'self';
    if (
      this.isFamilyMemberMedicate == 'No' &&
      this.formFl.referralMemberList.length > 0
    ) {
      this.formFl.referralMemberList = [];
    }
    this.formFl.referralMemberList.push(this.memberObj1);
    this.formFl.referralMemberList?.forEach((object) => {
      if (object.ssnNum != '') {
        object.ssnNum = object.ssnNum.replaceAll('-', '');
        object.memberPierId = null;
      }
    });

    let employerPremium = this.formFl.referralPolicy.employerPremium;
    if (employerPremium == '') employerPremium = '0';
    this.formFl.referralPolicy.employerPremium = parseFloat(employerPremium!).toFixed(
      2
    );

    let premiumAmt = this.formFl.referralPolicy.employeePremium;
    if (premiumAmt == '') premiumAmt = '0';
    this.formFl.referralPolicy.employeePremium = parseFloat(
      premiumAmt!
    ).toFixed(2);

    this.formFl.referralCase.useAch = this.directDepositCheck ==true;
    this.formFl.referralCase.phone1Num =
      this.formFl.referralCase.phone1Num?.replaceAll('-', '');
    this.formFl.referralCase.phone2Num =
      this.formFl.referralCase.phone2Num?.replaceAll('-', '');
    this.formFl.referralPolicy.phoneNum =
      this.formFl.referralPolicy.phoneNum?.replaceAll('-', '');
    this.formFl.referralEmployer.phoneNum =
      this.formFl.referralEmployer.phoneNum?.replaceAll('-', '');
    this.formFl.referralEmployer.emplyrFein =
      this.formFl.referralEmployer.emplyrFein?.replaceAll('-', '');
    this.formFl.referralEmployer.zipCd =
      this.formFl.referralEmployer.zipCd?.replaceAll('-', '');
      this.formFl.referralEmployer.faxNum =
      this.formFl.referralEmployer.faxNum?.replaceAll('-', '');
    this.formFl.referralAddressList?.forEach((object) => {
      if (object.zipCd != '') {
        object.zipCd = object.zipCd?.replaceAll('-', '');
      }
    });
    this.formFl.referralPolicy.zipCd =
      this.formFl.referralPolicy.zipCd?.replaceAll('-', '');
    if (!this.alreadySubmitted) {
      this.alreadySubmitted = true;
      this.warningMessage =
        'Processing your request, please wait.... <div class="spinner-border text-primary" role="status"></div>';
      window.scrollTo(0, 0);
      this.dataService.insertCustomerForm(this.formFl).subscribe({
        next: (response: ReferralResponse) => {
          if (response) {
            this.warningMessage = '';
            this.successMessage =
              'Your application has been submitted successfully.';

            // Mark form as pristine so that CanDeactivateGuard won't prompt before navigation
            //this.referral.memberVOLst.pop();
            this.isValidFormSubmitted = true;
            this.submittedResponse = response;
            //console.log('ResponseId: '+insertedCustomer.reponseID)
            //this.router.navigate(['/customers']);
            setTimeout(() => {
              this.successMessage = '';
            }, 2000);
          } else {
            this.formFl.referralMemberList.pop();
            const msg =
              'We are unable to save application details currently, please contact customer support.';
            this.errorMessage = msg;
          }
          window.scrollTo(0, 0);
        },
        error: (err: HttpErrorResponse) => {
          this.warningMessage = '';
          this.logger.logMsg(err.error);
          this.apiError = err;
          const msg =
            'We are unable to save application details currently, please contact customer support.';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          this.isValidFormSubmitted = true;
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },
        complete: () => {
          this.logger.logMsg('FL Application Form is submitted ');
        },
      });

      if (this.errorMessage != '') {
        window.scrollTo(0, 0);
        this.customerForm?.resetForm();
      }
    }
  }
  cancel(event: any) {
    event.preventDefault();
    this.changeResetMessage();
    window.scrollTo(0, 0);
  }

  removeSavedFamilyMembers(event: any) {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.formFl.referralMemberList = [];
    this.additionalMaxReached = false;
    this.additionalMembersReq = false;
    this.clear(event);
  }

  existingMemberFn() {
    this.updateReason = '';
    this.updateReasonRequired = false;
    this.emailTxtRequired = false;
    this.memberVOmaNumRequired = false;
    this.memberGenderRequired = false;
    this.refferalSourceRequired = false;
    this.firstNameRequired = false;
    this.lastNameRequired = false;
    this.homelessRequired = false;
    this.ssnMemberRequired = false;
    this.memberDobRequired = false;
    this.memberGenderRequired = false;
    this.memberMedicateRequired = false;
    this.pregnantMemberRequired = false;
    this.homelessCountyRequired = false;
    this.resAddress1Required = false;
    this.resParishRequired = false;
    this.resCityRequired = false;
    this.resStateRequired = false;
    this.resZipRequired = false;
    this.isSameRequired = false;
    this.mailAddress1Required = false;
    this.mailParishRequired = false;
    this.mailCityRequired = false;
    this.mailStateRequired = false;
    this.mailZipRequired = false;
  }
  verifySSN(event: any, isOtherSsn: boolean, control: NgModel) {
    this.phoneCheck(event,control);
    let ssn = event.target.value;
    let donepatt = /^(\d{3})-(\d{2})-(\d{4})$/;
    if (ssn.match(donepatt)) {
      let check: boolean = ValidationService.isSSNValidValue(ssn);
      if (!check) {
        if (!isOtherSsn) {
          this.MemberSsn.control.setErrors({
            ...(this.MemberSsn.control.errors || {}),
            invalidSsn: true,
          });
          return false;
        }
        if (isOtherSsn) {
          this.otherSsn.control.setErrors({
            ...(this.otherSsn.control.errors || {}),
            invalidSsn: true,
          });
          return false;
        }
      }

      if (isOtherSsn && this.memberObj1.ssnNum == ssn) {
        this.ssnValidationError = 'Duplicate ssn in the form';
        this.otherSsn.control.setErrors({
          ...(this.otherSsn.control.errors || {}),
          duplicate: true,
        });
        return false;
      }

      for (let othermember of this.formFl.referralMemberList) {
        if (isOtherSsn && othermember.ssnNum == ssn && (this.editIndex == undefined || this.getIndexByName(ssn) !==this.editIndex )) {
          this.ssnValidationError = 'Duplicate ssn in the form';
          this.otherSsn.control.setErrors({
            ...(this.otherSsn.control.errors || {}),
            duplicate: true,
          });
          return false;
        }
      }
    }

    return false;
  }
  getIndexByName(name: string): number {
    return this.formFl.referralMemberList.findIndex(item => item.ssnNum === name);
  }
  sameMailingAddress() {
    this.mailAddressFormControl.patchValue({
      address1Txt: '',
      address2Txt: '',
      stateCd: '',
      zipCd: '',
      cityTxt: ''
    })
    this.showMailAddress = false;
    this.mailAddress1Required = false;
    this.mailParishRequired = false;
    this.mailCityRequired = false;
    this.mailStateRequired = false;
    this.mailZipRequired = false;
  }
  addFamilyMember(event: Event) {
    this.addClearFamilyFilled = false;
    let valid = true;
    const form = this.customerForm?.form;

    if (form != null) {
      let page1 = addFamilyMemberFields;
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
    }
    if (this.formFl.referralMemberList.length > 50) {
      this.additionalMaxReached = true;
    }

    if (valid && !this.additionalMaxReached) {
      this.addFamilyMemberButton = true;
      if (
        (this.otherdobDate != null && this.otherDob!=null &&  this.otherDob.control.value !='') &&
        this.otherfirstNm != '' &&
        this.otherlastNm != '' &&
        this.otherEnrolled != '' &&
        this.otherssnNum != '' &&
        this.othermaNum !='' &&
        this.othergencdRf !='' &&
        this.otherrshcdRf != ''
      ) {
        if (this.memberObj1.ssnNum == this.otherssnNum) {
          this.ssnValidationError = 'Duplicate ssn in the form';
          this.otherSsn.control.setErrors({ duplicate: true });
          return;
        }

        if (this.editIndex != undefined) {
          this.formFl.referralMemberList.splice(this.editIndex, 1);
          this.editIndex = undefined;
        }
        let otherMembPierId: string |null =null;
        if(this.memberPierId == null && this.formFl.referralMemberList.length > 0){

          this.formFl.referralMemberList.forEach(mem => {
            if (otherMembPierId == null && mem.memberPierId != null){
              otherMembPierId=  mem.memberPierId;
            }
          });
        }
        this.verifyMember.firstNm = this.otherfirstNm;
        this.verifyMember.lastNm = this.otherlastNm;
        this.verifyMember.dobDt = this.getServerDate(this.otherdobDate);
        this.verifyMember.ssnNum = this.otherssnNum;
        this.verifyMember.pierId = this.memberPierId != null? this.memberPierId: otherMembPierId;

        this.verifyMember.ssnNum = this.verifyMember.ssnNum.replaceAll('-', '');
        this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({
          next: (response: verifyMemberResponse) => {
            if (response) {
              if (response.addMember == true && response.existingMember == true && response.pierId != null) {
                this.otherMemberPierId = response.pierId;
                this.existingOtherMember = 'Yes';
              }
              this.addMember = response.addMember;

            }
            if (!this.addMember) {
              this.existingInvalidMemberName =
                this.verifyMember.firstNm + ' ' + this.verifyMember.lastNm;
              this.addFamilyMemberButton = false;
              this.openDialog();
              return;
            } else {
              if(this.otherfirstNm !='' && this.otherlastNm != '' && this.otherssnNum !=''){
              this.formFl.referralMemberList.push({
                dobDt: this.getServerDate(this.otherdobDate),
                firstNm: this.otherfirstNm,
                lastNm: this.otherlastNm,
                miNm: this.othermiNm,
                ssnNum: this.otherssnNum,
                maNum: this.othermaNum,
                genderCd: this.othergencdRf,
                relationshipCd: this.otherrshcdRf,
                recipientPerson: true,
                otherEnrolledResp: this.otherEnrolled,
                existingMember: this.existingOtherMember == 'Yes',
                memberPierId: this.otherMemberPierId,
                enrolledInPolicy: this.otherEnrolled == 'Yes'
              });
            }
              this.checkAdditionalMembers();
              this.additionalMembersReq = false;
              this.addClearFamilyFilled = false;
              this.clear(event);
              this.otherdobDate = null;
              this.otherfirstNm = '';
              this.otherlastNm = '';
              this.othermiNm = '';
              this.otherssnNum = '';
              this.othermaNum = '';
              this.othergencdRf = '';
              this.otherrshcdRf = '';
              this.otherSpecialCond = '';
              this.otherMemberPierId = null;
              this.existingOtherMember ='';
            }
          },
          error: (err: HttpErrorResponse) => {
            this.logger.logMsg(err.error);
            const msg =
              'We are unable to verify Member details currently, please contact customer support.';
            this.errorMessage = msg;
            window.scrollTo(0, 0);
            setTimeout(() => {
              this.errorMessage = '';
            }, 3000);
          },
        });
      } else {
        if (this.otherfirstNm == '') {
          this.otherFnRequired = true;
        }
        if (this.otherlastNm == '') {
          this.otherLnRequired = true;
        }
        if (this.otherEnrolled == '') {
          this.otherEnrolledRequired = true;
        }

        if (this.otherssnNum == '') {
          this.otherSsnRequired = true;
        }
        if (this.otherDob.control.value ==null || this.otherDob.control.value =='') {
          this.otherDobRequired = true;
        }
        if (this.othermaNum == '') {
          this.othermaNumRequired = true;
        }
        if (this.othergencdRf == '') {
          this.otherGnRequired = true;
        }
        if (this.otherrshcdRf == '') {
          this.otherRsRequired = true;
        }
      }
      this.addFamilyMemberButton = false;
    }else{
      if (this.otherfirstNm == '') {
        this.otherFnRequired = true;
      }
      if (this.otherlastNm == '') {
        this.otherLnRequired = true;
      }
      if (this.otherEnrolled == '') {
        this.otherEnrolledRequired = true;
      }

      if (this.otherssnNum == '') {
        this.otherSsnRequired = true;
      }
      if (this.otherDob.control.value ==null || this.otherDob.control.value =='') {
        this.otherDobRequired = true;
      }
      if (this.othermaNum == '') {
        this.othermaNumRequired = true;
      }
      if (this.othergencdRf == '') {
        this.otherGnRequired = true;
      }
      if (this.otherrshcdRf == '') {
        this.otherRsRequired = true;
      }
    }
  }
  checkAdditionalMembers() {
    if (
      this.isFamilyMemberMedicate == 'Yes' &&
      this.formFl.referralMemberList.length == 0
    ) {
      return false;
    } else {
      return true;
    }
  }
  removeMember(memberIndex: number): void {
    this.formFl.referralMemberList.splice(memberIndex, 1);
    if (this.formFl.referralMemberList.length == 0) {
      this.additionalMembersReq = true;
    }
    if (this.formFl.referralMemberList.length <= 50) {
      this.additionalMaxReached = false;
    }
  }

  editMember(memberIndex: number): void {
    let obj = this.formFl.referralMemberList[memberIndex];
    this.editIndex = memberIndex;
    this.otherfirstNm = obj.firstNm;
    this.otherlastNm = obj.lastNm;
    this.otherssnNum = obj.ssnNum;
    this.othermaNum = obj.maNum;
    this.othermiNm = obj.miNm;
    this.othergencdRf = obj.genderCd;
    this.otherrshcdRf = obj.relationshipCd;
    this.otherdobDate = moment(obj.dobDt, 'MM/DD/YYYY').toDate();
    this.otherEnrolled = obj.otherEnrolledResp!;
  }
  allowAlphaNumericWithSplChar(event: any) {
    return ValidationService.allowAlphaNumericWithSplChar(
      event,
      this.deviceDetectorService.browser
    );
  }

  verifyMemberFn(dobDt: NgModel) {
    let requiredFields: boolean =
      this.memberObj1.firstNm != '' &&
      this.memberObj1.lastNm != '' &&
      this.memberObj1.ssnNum != '' &&
      this.memberVOdobDt != null;

    if (!requiredFields) {
      this.firstNameRequired = true;
      this.lastNameRequired = true;
      this.ssnMemberRequired = true;
      if(!(dobDt.control.errors && dobDt.control.errors['invalidDate'])){
        this.memberDobRequired = true;
      }
    }

    let valid = true;
    const form = this.customerForm?.form;

    if (requiredFields && form != null) {
      let page1 = [
        'memberVO.firstNm',
        'memberVO.lastNm',
        'memberObj.ssnNum',
        'd1',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
    }

    if (requiredFields && valid) {
      this.verifyMember.firstNm = this.memberObj1.firstNm;
      this.verifyMember.lastNm = this.memberObj1.lastNm;
      this.verifyMember.dobDt = this.getServerDate(this.memberVOdobDt);
      this.verifyMember.ssnNum = this.memberObj1.ssnNum;
      this.verifyMember.pierId = this.memberPierId;

      this.verifyMember.ssnNum = this.verifyMember.ssnNum.replaceAll('-', '');
      this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({
        next: (response: verifyMemberResponse) => {
          if (response) {
            this.memberPierId = response.pierId;
            this.addMember = response.addMember;
            this.existingMember = response.existingMember == true ? 'Yes' : 'No';
            this.memberObj1.existingMember = response.existingMember;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.logger.logMsg(err.error);
          const msg =
            'We are unable to verify Member details currently, please contact customer support.';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },
      });
    }
    this.timerReset =Math.random()* 100;
  }

  getServerDate(dateStruct: Date | null) {
    if (dateStruct != null) {
      return this.datePipe.transform(dateStruct, 'MM/dd/yyyy');
    }
    return null;
  }
  public changeSuccessMessage() {
    this._success.next(`${new Date()} - Form submitted successfully.`);
  }
  public changeResetMessage() {
    this._warning.next(` Form reset done.`);
  }
  allowAlphabets(event: any) {
    return ValidationService.allowAlphabets(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphabets2(event: any, control: NgModel) {
    return ValidationService.allowAlphabets2(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericWithSplChars(event: any,control: NgModel){
    return ValidationService.allowAlphaNumericWithSplChars(
      event,
      this.deviceDetectorService.browser,
      control
    );


  }
  allowAlphaNumericWithTwoSplChar(event: any, control: NgModel){
    return ValidationService.allowAlphaNumericWithTwoSplChar(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericForCarrier(event: any, control: NgModel){
      return ValidationService.allowAlphaNumericForCarrier(
        event,
        this.deviceDetectorService.browser,
        control
      );
  }
  allowAlphaNumericWithoutSpace(event: any, control: NgModel) {
    return ValidationService.allowAlphaNumericWithoutSpace(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  allowAlphaNumericWithSpace(event: any, control: NgModel) {
    return ValidationService.allowAlphaNumericWithSpace(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }

  isNumeric(elem: any, control: NgModel) {
    return ValidationService.isNumeric2(
      elem,
      this.deviceDetectorService.browser,
      control
    );
  }

  oneSpaceAllowed(event: any) {
    return ValidationService.oneSpaceAllowed(event);
  }

  allowAlphaNumeric(event: any) {
    return ValidationService.allowAlphaNumeric(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphaNumericWithSplHash(event: any) {
    return ValidationService.allowAlphaNumericWithSplHash(
      event,
      this.deviceDetectorService.browser
    );
  }
  validatePremiumAmountFormat(event: any) {
    return ValidationService.validatePremiumAmountFormat(
      event,
      this.deviceDetectorService.browser
    );
  }
  ssnmask(ssn: any, control: NgModel) {
    return ValidationService.ssnmask(ssn, control);
  }

  async setDefaultBlank(event: any, controlName: string, formGroup: FormGroup, propName: string){
    let cityTxt =formGroup.controls['cityTxt'];
    let stateCd =formGroup.controls['stateCd'];
    let zipCd =formGroup.controls['zipCd'];
    const key = event.keyCode || event.charCode;
    if(this.addressSuggestions[propName].length >0 && event.target.value.length < 6){
      this.addressSuggestions[propName] = [];
    }
   
  if((event.ctrlKey && event.key === 'v') || (event.ctrlKey && event.key === 'c') || key != 37 && key != 38 && key != 39 && key != 40 && event.keyCode!=13 && event.keyCode!= 9){     
    if(cityTxt.value !='' || stateCd.value !='' || zipCd.value !='' || key === 8 || key === 46  ||(event.ctrlKey && event.key === 'x')){
       
       if(controlName =='mailAddress.addressLine1Txt'){
         this.showMailAddress=false;
       }else if(controlName =='caseVO.addressLine1Txt'){
       this.showResAddress=false;
       } else if(controlName =='employerVO.addressLine1Txt') {
         this.showEmployerAddress = false;
       } else if(controlName =='policyVO.addressLine1Txt') {
         this.showPolicyAddress = false;
       }
       formGroup.patchValue({
         address2Txt: '',
         cityTxt: '',
         stateCd: '',
         zipCd: '',
       });
     }
     if(controlName =='caseVO.addressLine1Txt' && this.resAddressFormControl.getRawValue()?.address1Txt?.includes('PO BOX')){
      this.resAddressFormControl.controls.address1Txt.setErrors({'po': true});
     }
    }

 }

 selectSuggestion(fromGroup: FormGroup,name:string, control: FormControl, suggestion: any, trigger: any, propName: string) {
  if(suggestion?.option?.value?.secondary && suggestion?.option?.value?.entries > 1 ){
    this.disableSearch = true;
    const selectedAddress = suggestion?.option?.value?.street_line +' '+ suggestion?.option?.value?.secondary + ' ('+suggestion?.option?.value?.entries + ') '+
    suggestion?.option?.value?.city +' '+ suggestion?.option?.value?.state +' '+ suggestion?.option?.value?.zipcode;
    control.setValue(suggestion?.option?.value?.street_line.toUpperCase());

    this.addressSuggestions[propName] = [];
    this.setPreviousVal(suggestion?.option?.value?.street_line, propName);
    this.addressService.autocompleteSelectedAddress(suggestion?.option?.value?.street_line.toUpperCase(), selectedAddress).then(
      (data:any)=> {
        this.addressSuggestions[propName] = data.suggestions;
        if(trigger) {
          trigger.openPanel();
        }
        setTimeout (() => {
          this.disableSearch = false;
        },9000)

      }
    )

    console.log("Address Suggestions: "+this.addressSuggestions);
  }  else{
  // selectSuggestion(control: NgModel, suggestion: any) {
    const address: ReferralAddress = {
      addressTypeCd: '',
      address1Txt: '',
      address2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: '',
    };
    this.addressSuggestions[propName] = [];
    control.setValue(suggestion?.option?.value?.street_line.toUpperCase());
    if(name =='mailAddress.addressLine1Txt'){
      address.addressTypeCd = 'M';
      this.showMailAddress=true;
      this.addressService.setAddressDetails(address,suggestion);
      this.mailAddressFormControl.patchValue(address);
    } else if(name =='employerVO.addressLine1Txt'){
      this.showEmployerAddress=true;
      this.addressService.setAddressDetails(address,suggestion);
      this.referralEmployerAddressFormControl.patchValue(address);
      this.formFl.referralEmployer = {...this.formFl.referralEmployer, ...address };
    } else if(name =='policyVO.addressLine1Txt'){
      this.showPolicyAddress = true;
      this.addressService.setAddressDetails(address,suggestion);
      this.referralPolicyAddressFormControl.patchValue(address);
      this.formFl.referralPolicy = {...this.formFl.referralPolicy, ...address};
    } else if(name =='caseVO.addressLine1Txt'){
      address.addressTypeCd = 'R';
      this.showResAddress=true;
      this.addressService.setAddressDetails(address,suggestion);
      this.resAddressFormControl.patchValue(address);
    }
  }
}


  phonemask2(phone: any, control: NgModel) {
    return ValidationService.phonemask2(phone, control);
  }

  datemask2(date: any, control: NgModel) {
    return ValidationService.datemask2(date, control);
  }
  onlyNumeric(elem: any, control: NgModel) {
    return ValidationService.onlyNumeric(
      elem,
      this.deviceDetectorService.browser,
      control
    ); 
  }
  isFEINValidValue(empFEIN: any, control: NgModel) {
    this.phoneCheck(empFEIN, control);
    let isValid = ValidationService.isFEINValidValue(empFEIN.target.value);
    if (!isValid) {
      control.control.setErrors({ ...(control.errors || {}), invalid: true });
    } else {
      if (control.control.errors) delete control.control.errors['invalid'];
    }
  }
  empFEINMask(empFEIN: any, control: NgModel) {
    return ValidationService.empFEINMask(empFEIN, control);
  }
  amountMask(amount: any, control: NgModel) {
    return ValidationService.amountMask(amount, control);
  }
  validatePremiumAmount(amount: any, control: NgModel) {
    return ValidationService.validatePremiumAmount(amount, control);
  }

  getSSNUsedMessage() {
    return ValidationService.getSSNUsedMessage2(this.faxNo);
  }

  getMessageServerDown() {
    return ValidationService.getMessageServerDown();
  }
  allowOnlyOneAlphabet(event: any, control: NgModel) {
    return ValidationService.allowOnlyOneAlphabet(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  openPdf() {
    let bytes = this.submittedResponse.submittedApplication;

    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    //window.open(fileURL);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.download = this.submittedResponse.referralId + '.pdf';
    anchor.click();
  }

  base64ToArrayBuffer(base64: any): ArrayBuffer {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  checkCaptch(event: any) {
    if (
      this.captchaEntered != '' &&
      this.captchaEntered != this.captchaText
    ) {
      this.captcha.control.setErrors({ nomatch: true });
      return false;
    } else {
      this.captcha.control.setErrors(null);
      return true;
    }
  }
  originalOrder = (
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number => {
    return 0;
  };

  openDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Family Member',
        content:
          `<br />
      <h1 class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> Invalid Member</h1>
      <p>This member <span class="text-danger">` +
          this.existingInvalidMemberName +
          `</span> details belongs to different case.</p>
      <p>Please re-check filled member details.</p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }

  openMedicaidDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Medicaid Member Required',
        content: `<br />
      <p>The FLHIPP program is specifically for qualifying Medicaid clients and their families who have access to group health insurance through a job. Based on your responses, you do not qualify for HIPP.</p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }
  compareDate(control: NgModel, control2: NgModel) {
    if (
      this.employerErollStartDate != null &&
      this.employerErollEndDate != null &&
      this.employerErollEndDate <= this.employerErollStartDate
    ) {
      control.control.setErrors({
        ...(control.errors || {}),
        invalidEndDate: true,
      });
    } else {
      if (control.control.errors)
        delete control.control.errors['invalidEndDate'];
      if (control2.control.errors && control2.control.errors['invalidEndDate'])
         control2.control.setErrors(null);
    }
  }
  isMedicaidValid(medicaid: any, control: NgModel) {
    this.phoneCheck(medicaid, control);
    let isValid = ValidationService.isMedicaidValid(medicaid.target.value);
    if (!isValid) {
      control.control.setErrors({ ...(control.errors || {}), invalid: true });
    } else {
      if (control.control.errors) delete control.control.errors['invalid'];
    }
  }
  routingNumberValidator(routingNum: any, control: NgModel) {
    //this.phoneCheck(routingNum, control);
    const routingNumber = routingNum.target.value;
    if (routingNumber.length == 9) {
      const weights = [3, 7, 1];
      let sum = 0;
      for (let i = 0; i < routingNumber.length; i++) {
        sum += parseInt(routingNumber[i], 10) * weights[i % 3];
      }

      if (sum % 10 === 0) {
        if (control.control.errors) delete control.control.errors['invalid'];
         this.isRoutingNumberValid= true;
        
      } else {
        control.control.setErrors({ ...(control.errors || {}), invalid: true });
         this.isRoutingNumberValid= false;
      }
    }
  }
  signApplicantCheck() {
    if (this.signApplicant == 'self' || this.signApplicant == 'onbehalf') { 
      this.formFl.referralCase.submitterFirstName = '';
      this.formFl.referralCase.submitterLastName = '';
    }
  }
  directDeposit() {
    this.accountType;
    this.depositBankName = '';
    this.depositRoutingNum = '';
    this.depositAccountNum = '';

    this.depositBankNmRequired = false;
    this.routingNumRequired = false;
    this.accountNumRequired = false;
    this.accountTypeRequired = false;
  }
  isMemberMedicaidClick() {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.memberObj1.maNum = '';
    this.memberVOmaNumRequired = false;
  }
  phoneCheck(event : any, control: NgModel ){
    if(event.target.value =='' && control.control.errors && (control.control.hasError('nomatch') || control.control.hasError('pattern'))){
      if(!control.control.hasError('required')){
        control.control.setErrors(null);
      }else{
        control.control.setErrors({...(control.errors || {}),'nomatch': false, 'required':true});
      }
    }
  }
  nomatchCheck(event : any, control: NgModel ){
    this.phoneCheck(event,control);
  }
  parseDate(date: any, control: NgModel){
    this.phoneCheck(date, control);
    let donepatt = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    if((date.target.value.length > 0 &&  date.target.value.length < 8) ){
      control.control.setErrors({...(control.errors || {}),'invalidDate': true,'required':false});
    }else{
      if(control.control.errors && control.control.hasError('invalidDate'))
      delete  control.control.errors['invalidDate'];
    }
    if(donepatt.test(date.target.value)){
      let parseDate =  moment(date.target.value, 'MM/DD/YYYY');
      if(!parseDate.isValid()){
        control.control.setErrors({...(control.errors || {}),'invalidDate': true,'required':false});
      }else{
        if(control.control.errors && control.control.errors['invalidDate'])
          delete  control.control.errors['invalidDate'];
      }
    } 
  }
  validateAddress(address1Txt: any, city: any, state: any, zipCd: any){
    if(address1Txt.value != ''){
      if( city.value =="" || state.value =="" || zipCd.value ==""){
        if(!(address1Txt.errors && address1Txt.hasError('po')))
        address1Txt.setErrors({...(address1Txt.errors || {}),'invalid': true,});
      }else{
        if(address1Txt.errors && address1Txt.hasError('invalid'))
          delete  address1Txt.errors['invalid'];
      }
    }else if(address1Txt.errors && !address1Txt.hasError('required')){
      address1Txt.setErrors(null);
    }
  }
  checkEmail(event : any){
    this.emailTxtRequired = false;
   }

   private setPreviousVal(tempSelectedStreetLine: any, propName: string) {
    if(config.validateAddresses){
    switch (propName) {
      case 'resAddress': this.previousValRes = tempSelectedStreetLine; break;
      case 'mailAddress': this.previousValMail = tempSelectedStreetLine; break;
      case 'referralEmployerAddress': this.previousValRefEmp = tempSelectedStreetLine; break;
      case 'referralPolicyAddress': this.previousValRefPol = tempSelectedStreetLine; break;
      default: "";
    }
  }
  }
  validateCarrierNm(event : any, control: NgModel ){
    let regex=/^(?![ \-/()])([a-zA-Z0-9]+(?: {0,1}(?:[\-/] {0,1})?[a-zA-Z0-9]+)*)(?: {0,1}\((?![ -])[A-Za-z]+(?:\s{0,1}[A-Za-z]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z]+)*\) *(?:[a-zA-Z0-9]+(?: {0,1}(?:[\-/] *)?[a-zA-Z0-9]+)*)*)?(?![ \-/()])$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePlanNm(event : any, control: NgModel ){
    let regex=/^(?![ .,\/#&-])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[.,\/#&-]\s{0,1}(?![ .,\/#&-])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validateGroupNum(event : any, control: NgModel ){
    let regex=/^(?![ -])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePolicyId(event : any, control: NgModel ){
    let regex=/^[a-zA-Z0-9]+$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
}

